import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../lib/auth';

const SHIELD = "M12 2L4 5.5V11C4 15.97 7.45 20.61 12 22C16.55 20.61 20 15.97 20 11V5.5L12 2Z";
const CHECK  = "M8.5 12.5L11 15L15.5 9.5";
const INACTIVITY_MINUTES = 30;

export default function Topbar() {
  const { client, logout } = useAuth();
  const initials = client?.name?.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase() || 'VIP';
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => { logout(); }, INACTIVITY_MINUTES * 60 * 1000);
  };

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll'];
    events.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();
    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  useEffect(() => {
    const handler = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div style={{
      height: 'var(--nav-h)', background: 'var(--bg-surface)',
      borderBottom: '0.5px solid var(--border)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 16px', flexShrink: 0, position: 'relative',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 9, fontSize: 14, fontWeight: 500, letterSpacing: '0.1em', color: 'var(--gold)' }}>
        <div style={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d={SHIELD} fill="#c8b48a" opacity="0.2" stroke="#c8b48a" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d={CHECK} stroke="#c8b48a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        SHAHEEN
      </div>

      <div ref={menuRef} style={{ position: 'relative' }}>
        <div
          onClick={() => setMenuOpen(o => !o)}
          style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--bg-raised)', border: '0.5px solid var(--border)', borderRadius: 20, padding: '4px 12px 4px 5px', cursor: 'pointer' }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--green)' }} />
          <div style={{ width: 24, height: 24, borderRadius: '50%', background: 'var(--gold-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 500, color: 'var(--gold)' }}>{initials}</div>
          <span style={{ fontSize: 12, color: 'var(--text-secondary)', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{client?.name?.split(' ')[0] || 'VIP'}</span>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="2"><path d="M6 9l6 6 6-6"/></svg>
        </div>

        {menuOpen && (
          <div style={{ position: 'absolute', right: 0, top: 44, background: 'var(--bg-surface)', border: '0.5px solid var(--border)', borderRadius: 10, minWidth: 180, zIndex: 100, overflow: 'hidden' }}>
            <div style={{ padding: '12px 16px', borderBottom: '0.5px solid var(--border)' }}>
              <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-primary)' }}>{client?.name}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 1 }}>{client?.id}</div>
            </div>
            <div style={{ padding: '6px 0' }}>
              <button
                onClick={() => { setMenuOpen(false); logout(); }}
                style={{ width: '100%', textAlign: 'left', padding: '9px 16px', fontSize: 13, color: 'var(--red)', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
                Sign out
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
